<template>
  <div
    :class="`menu-toggle ${drawer ? 'menu-toggle--active' : ''}`"
    @click="onMenuToggle"
  >
    <div class="menu-toggle--1"></div>
    <div class="menu-toggle--2"></div>
    <div class="menu-toggle--3"></div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify"

export default {
  computed: {
    ...sync("app", ["drawer"]),
  },
  methods: {
    onMenuToggle() {
      this.drawer = !this.drawer
    },
  },
}
</script>

<style scoped>
.menu-toggle {
  margin-left: 2rem;
  display: none;
}

@media (max-width: 1262px) {
  .menu-toggle {
    display: block;
  }
}

.menu-toggle div {
  width: 35px;
  height: 3px;
  background-color: #333;
  margin: 6px 0;
  transition: 0.4s;
}

.menu-toggle--active .menu-toggle--1 {
  -webkit-transform: rotate(-45deg) translate(-7px, 6px);
  transform: rotate(-45deg) translate(-7px, 6px);
}

.menu-toggle--active .menu-toggle--2 {
  opacity: 0;
}
.menu-toggle--active .menu-toggle--3 {
  -webkit-transform: rotate(45deg) translate(-6px, -6px);
  transform: rotate(45deg) translate(-6px, -6px);
}
</style>
